import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=1a95aa40&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"
import style0 from "./Collection.vue?vue&type=style&index=0&id=1a95aa40&prod&scoped=true&lang=less"
import style1 from "./Collection.vue?vue&type=style&index=1&id=1a95aa40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95aa40",
  null
  
)

export default component.exports